const initialState = {
  blfrs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BL_FRS_SELECT":
      return {
        ...state,
        blfrs: action.payload,
      };
    default:
      return state;
  }
}
